import { Component, Input, Output, EventEmitter, signal, inject, OnInit, OnChanges, SimpleChanges, ChangeDetectionStrategy } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { TranslatePipe } from '@ngx-translate/core';
import { Feedback } from '../../../core/services/satisfaction.service';
import { MessageTemplate, MessageTemplateService } from '../../../core/services/message-template.service';
import { SessionService } from '../../../core/session.service';

@Component({
  selector: 'app-bulk-reply-modal',
  standalone: true,
  imports: [CommonModule, FormsModule, TranslatePipe],
  templateUrl: './bulk-reply-modal.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrls: ['./bulk-reply-modal.component.scss']
})
export class BulkReplyModalComponent implements OnInit, OnChanges {
  private templateService = inject(MessageTemplateService);
  private session = inject(SessionService);
  @Input() show = false;
  @Input() selectedFeedbacks: Feedback[] = [];
  
  @Output() close = new EventEmitter<void>();
  @Output() sendBulkReply = new EventEmitter<{subject: string, message: string}>();

  emailTemplates = signal<MessageTemplate[]>([]);
  selectedTemplate = '';
  bulkReplySubject = '';
  bulkReplyMessage = '';

  ngOnChanges(changes: SimpleChanges) {
    if (changes['show']) {
      if (this.show) {
        document.body.classList.add('modal-open');
        if (this.selectedFeedbacks.length > 0) {
          this.initializeForm();
        }
      } else {
        document.body.classList.remove('modal-open');
      }
    } else if (changes['selectedFeedbacks'] && this.show && this.selectedFeedbacks.length > 0) {
      this.initializeForm();
    }
  }

  ngOnInit() {
    if (this.show && this.selectedFeedbacks.length > 0) {
      this.initializeForm();
    }
  }

  private initializeForm() {
    this.bulkReplySubject = '';
    this.bulkReplyMessage = '';
    this.selectedTemplate = '';
    this.loadEmailTemplates();
  }

  private loadEmailTemplates() {
    const selectedId = this.session.selectedId();
    const establishment = this.session.establishments().find(e => e.id === selectedId);
    if (!establishment?.org_id) return;

    this.templateService.getTemplatesByType('EMAIL_REPLY', establishment.org_id).subscribe({
      next: (templates) => {
        this.emailTemplates.set(templates);
        // Sélectionner automatiquement le premier template
        if (templates.length > 0) {
          this.selectedTemplate = templates[0].name;
          this.onTemplateSelect();
        }
      },
      error: (err) => {
        console.error('Template loading failed:', err?.message?.replace(/[\r\n]/g, ' ') || 'Unknown error');
      }
    });
  }

  onTemplateSelect() {
    const template = this.emailTemplates().find(t => t.name === this.selectedTemplate);
    if (template) {
      this.bulkReplyMessage = template.content;
      if (template.subject) {
        this.bulkReplySubject = template.subject;
      }
    }
  }

  onSendBulkReply() {
    if (!this.bulkReplyMessage.trim()) return;
    this.sendBulkReply.emit({
      subject: this.bulkReplySubject,
      message: this.bulkReplyMessage
    });
  }

  onClose() {
    this.bulkReplySubject = '';
    this.bulkReplyMessage = '';
    this.selectedTemplate = '';
    this.close.emit();
  }
}